import { render, staticRenderFns } from "./update.vue?vue&type=template&id=a68b201a&"
import script from "./update.vue?vue&type=script&lang=js&"
export * from "./update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a68b201a')) {
      api.createRecord('a68b201a', component.options)
    } else {
      api.reload('a68b201a', component.options)
    }
    module.hot.accept("./update.vue?vue&type=template&id=a68b201a&", function () {
      api.rerender('a68b201a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/update.vue"
export default component.exports